import { Typography, Button, Row, Col }  from 'antd'
import LatestPosts from '../latestPosts/latestPosts.component.js'
import Breakpoint from '../../enums/breakpoint.enum.js'
import useWidth from '../../hooks/useWidth.hook.js'

const { Text, Paragraph } = Typography

export const FullBodyMriApproval = ({ flow }) => {
  const width = useWidth()

  const instructions = [
    {
      sections: [{
        title: 'Schedule Your Scan',
        description: <>We’ll reach out to arrange your MRI at {flow?.facility?.name ? flow?.facility?.name : 'your selected location'}.</>
      }]
    }, 
    {
      sections: [{
        title: 'Get Scan Done',
        description: <>No pre-scan prepartion is required. Your appointment will last approximately 1 hour.</>
      }]
    }, 
    {
      sections: [{
        title: 'View Results Online',
        description: <>A specialist will guide you through your results. You also have the option to consult with one of our longevity physicians for a deeper review.</>
      }]
    }
  ]

  return (
    <div className="prescription-approval">


      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

  
    </div>
  )
}
